module.exports = __webpack_public_path__ + "static/7e-65601d921d9c1af898e041509c1f0ed5.png";